import React from 'react'

const SearchInput = React.forwardRef((props, ref) => (
  <label className='template-search'>
    <span className='fa fa-search' />
    <input className='search-input' {...props} ref={ref} />
  </label>
))

export default SearchInput
